import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../../components/shared/Button/Button';
import CustomTextField from '../../../../components/shared/CustomTextField/CustomTextField';
import Modal from '../../../../components/shared/Modal/Modal.jsx';
import { IsMobile } from '../../../../helpers/IsMobile';

import styles from './CreateTagModal.module.scss';

const CreateTagModal = ({ showModal, handleToggleCreateModal, handleAddTag }) => {
  const { t } = useTranslation('common');
  const isMobile = IsMobile();
  const [tagValue, setTagValue] = useState('');

  return (
    <Modal
      show={showModal}
      onHide={handleToggleCreateModal}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen={isMobile}
    >
      <Modal.CustomHeader closeButton>
        <Modal.Title id="contained-modal-title-vcenter">{t('tags.createTag')}</Modal.Title>
      </Modal.CustomHeader>
      <Modal.Body>
        <CustomTextField
          value={tagValue}
          onChange={(e) => setTagValue(e.target.value)}
          type="text"
          label={t('tags.addNewTag')}
        />
      </Modal.Body>
      <Modal.CustomFooter>
        <Button variant="outline-primary" onClick={() => handleAddTag(tagValue)} className={styles.yesNoBtn}>
          {t('save')}
        </Button>
        <Button variant="primary" onClick={handleToggleCreateModal} className={styles.yesNoBtn}>
          {t('cancel')}
        </Button>
      </Modal.CustomFooter>
    </Modal>
  );
};

export default CreateTagModal;
